<template>
  <el-table
    :data="serialData"
    class="table-content rounded-xl w-full"
    header-cell-class-name="custom-table__header-cell"
    cell-class-name="custom-table__cell cursor-pointer"
    border
    :empty-text="$t('empty')"
    highlight-current-row
    ref="tableRef"
    @row-click="handleRowClick"
    @sort-change="handleSortChange"
  >
    <el-table-column
      v-for="col in tableColumns"
      :key="col.prop"
      :prop="col.prop"
      :label="col.label"
      :min-width="20"
      :sortable="col.sortable"
    >
      <template v-slot="scope">
        <span v-if="col.formatter">{{ col.formatter(scope.row) }}</span>
        <span v-else>{{ scope.row[col.prop] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { ISerial } from '@/utils/types/model/serial'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  formatter?: (row: ISerial) => string
}

const amountWithUnit = (amount: number, unit?: string) => (unit ? `${amount} (${unit})` : `${amount}`)

@Options({
  name: 'SerialList',
  emits: ['detail', 'sort-change'],
})
export default class SerialList extends Vue {
  @Prop({ type: Array, default: () => [] }) serialData!: ISerial[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'code', label: this.$t('serial_code'), sortable: 'custom' },
      { prop: 'itemCode', label: this.$t('item_code') },
      { prop: 'itemName', label: this.$t('item_name') },
      {
        prop: 'currentAmount',
        label: this.$t('current_amount'),
        formatter: (row: ISerial) => amountWithUnit(row.currentAmount, row.unit),
      },
      {
        prop: 'limitAmount',
        label: this.$t('limit_amount'),
        formatter: (row: ISerial) => amountWithUnit(row.limitAmount, row.unit),
      },
      { prop: 'conversionUnit', label: this.$t('conversion_unit') },
    ]
  }

  handleRowClick(row: ISerial) {
    this.$emit('detail', row.code)
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
</script>
